import { ChevronLeft, ChevronRight } from 'lucide-react';

function getPageItems(page, pageCount) {
  if (pageCount <= 7) {
    return Array.from({ length: pageCount }, (_, i) => i + 1);
  }
  const items = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(pageCount - 1, page + 1);
  if (start > 2) items.push('...');
  for (let n = start; n <= end; n++) items.push(n);
  if (end < pageCount - 1) items.push('...');
  items.push(pageCount);
  return items;
}

export default function Pagination({
  page,
  pageCount,
  onChange,
  range,
  className = '',
}) {
  if (!pageCount || pageCount < 1) return null;

  return (
    <div className={`table-pagination ${className}`.trim()}>
      {range && <span className="table-pagination__range">{range}</span>}
      <div className="table-pagination__controls">
        <button
          type="button"
          className="table-pagination__btn"
          disabled={page <= 1}
          onClick={() => onChange(Math.max(1, page - 1))}
          aria-label="Halaman sebelumnya"
        >
          <ChevronLeft size={16} />
        </button>
        {getPageItems(page, pageCount).map((item, i) =>
          item === '...' ? (
            <span key={`gap-${i}`} className="table-pagination__ellipsis">
              ...
            </span>
          ) : (
            <button
              key={item}
              type="button"
              className={`table-pagination__btn${
                item === page ? ' table-pagination__btn--active' : ''
              }`}
              onClick={() => onChange(item)}
              aria-current={item === page ? 'page' : undefined}
            >
              {item}
            </button>
          )
        )}
        <button
          type="button"
          className="table-pagination__btn"
          disabled={page >= pageCount}
          onClick={() => onChange(Math.min(pageCount, page + 1))}
          aria-label="Halaman berikutnya"
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
}
